import Cookies from 'js-cookie';

const MINDBOX_DEVICE_UUID_COOKIE = 'mindboxDeviceUUID';

export function getMindboxDeviceUuid(): string {
  return Cookies.get(MINDBOX_DEVICE_UUID_COOKIE) ?? '';
}
